module.exports = __webpack_public_path__ + "img/merit-3.68b960e3.png";